<template>
    <div style="background-color: #f5f5f5; height: 100%">
        <div class="pa-5">
            <div>
                <v-container class="my-5">
                    <ExportAll />

                    <v-row>
                        <Profile
                            v-for="profile in profiles"
                            :profile="profile"
                            :registries="registries"
                            :key="profile._id"
                            :loadProfiles="loadProfiles"
                            @destroy="destroyProfile"
                        />
                    </v-row>
                </v-container>
            </div>
        </div>
    </div>
</template>
<script>
import Profile from './Profile'
import ExportAll from './ExportAll'

export default {
    components: {
        Profile,
        ExportAll,
    },
    data() {
        return {
            profiles: [],
            sendStatus: false
        }
    },
    created() {
        this.loadProfiles()
    },
    methods: {
        loadProfiles() {
            this.$axios.post('/api/profiles-admin', {}).then((res) => {
                this.profiles = res.data.profiles
                this.registries = res.data.registries
            })
        },
        trueStatus(element) {
            return element === true
        },
        destroyProfile(_id) {
            for (var i = 0; i < this.profiles.length; i++)
                if (this.profiles[i]._id === _id) {
                    this.profiles.splice(i, 1)
                    break
                }
        },
    },
}
</script>
